import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-delete-rol',
  templateUrl: './dialog-delete-rol.component.html',
  styleUrls: ['./dialog-delete-rol.component.css']
})
export class DialogDeleteRolComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
